import { Marker, InfoBox } from "@react-google-maps/api";
import "./style.scss";
import { useState } from "react";
import { VehicleStopResponse } from "types/trip.types";
import { ColorSpectrum } from "types/ColorSpectrum";
interface HubMarkerProps {
  stop: VehicleStopResponse;
  stopIndex: number;
  color?: ColorSpectrum;
  highlight?: boolean;
  displayComputed?: boolean;
  tripId?: number;
  /* eslint-disable */
  onHover?: (stopId: number, isOver: boolean) => void;
  onAction?: (action: string, params?: any) => void;
  /* eslint-enable */
}
export default function HubMarker({
  stop,
  stopIndex,
  color,
  highlight,
  tripId,
  onAction,
  displayComputed,
}: HubMarkerProps) {
  const stopCompleted = true;
  const [clicked, setClicked] = useState(false);
  const handleClick = () => {
    setClicked(!clicked);
    onAction && onAction("map-stop-click", { point: stop, tripId });
  };
  return (
    <>
      <Marker
        position={{ lat: stop.latitude, lng: stop.longitude }}
        // onMouseOver={() => {
        //   onHover && onHover(stop.tripStopId ?? 0, true);
        // }}
        // onMouseOut={() => {
        //   onHover && onHover(stop.tripStopId ?? 0, false);
        // }}
        icon={{
          path: "M -8,0 a 8,8 0 1,0 16,0 a 8,8 0 1,0 -16,0",
          strokeColor: color?.dark40,
          strokeWeight: 16,
          fillOpacity: 0.5,
        }}
      />
      <Marker
        position={{ lat: stop.latitude, lng: stop.longitude }}
        // onMouseOver={() => {
        //   onHover && onHover(stop.tripStopId ?? 0, true);
        // }}
        // onMouseOut={() => {
        //   onHover && onHover(stop.tripStopId ?? 0, false);
        // }}
        zIndex={highlight ? 99999 : undefined}
        icon={
          highlight
            ? {
                path: "M -8,0 a 8,8 0 1,0 16,0 a 8,8 0 1,0 -16,0",
                fillColor: color?.dark40,
                strokeColor: color?.dark40,
                strokeWeight: 30,
                fillOpacity: 0.5,
              }
            : {
                path: "M -12,0 a 12,12 0 1,0 24,0 a 12,12 0 1,0 -24,0",
                fillColor: stopCompleted
                  ? color?.main ?? "red"
                  : color?.light20,
                strokeColor: color?.main ?? "red",
                strokeWeight: 4,
                fillOpacity: 1,
              }
        }
        label={{
          text: "H",
          fontSize: "16pt",
          fontWeight: "bold",
          color: highlight ? color?.light20 : color?.dark40,
        }}
        onClick={handleClick}
      >
        {highlight && (
          <InfoBox onCloseClick={() => {}}>
            <div className="map-stop-info"></div>
          </InfoBox>
        )}
      </Marker>
    </>
  );
}
